import { useIntl } from "@components/Intl"
import { LabelS } from "@components/Typography"
import { getGraphQLClient } from "@lib/graphql-client"
import { RECENTLY_VIEWED_STORAGE_KEY } from "@screens/product/SaveRecentlyViewed"
import { useQuery } from "@tanstack/react-query"
import Cookies from "js-cookie"
import { FC, useEffect, useState } from "react"
import { Product } from "./product"

const { sdk } = getGraphQLClient()

type RecentlyViewedProps = {}

export const RecentlyViewed: FC<RecentlyViewedProps> = () => {
  const { locale } = useIntl()
  const [ids, setIds] = useState([])
  const articleCombinationsIds = ids.filter((item) => item.length <= 4)
  const articleIds = ids.filter((item) => item.length > 4)
  const { data: articleCombinationData } = useQuery(
    ["articleCombinations", articleCombinationsIds],
    () => sdk.ArticleCombinationsById({ ids: articleCombinationsIds })
  )
  const { data } = useQuery(["articles", articleIds], () =>
    sdk.ArticlesById({ ids: articleIds })
  )

  const hasArticleCombinations =
    articleCombinationData &&
    articleCombinationData.choicesArticleCombinationsById
  const hasArticles = data && data.choicesArticlesById

  useEffect(() => {
    const recentlyViewed = Cookies.get(RECENTLY_VIEWED_STORAGE_KEY)
    if (recentlyViewed) {
      setIds(JSON.parse(recentlyViewed))
    }
  }, [])

  return hasArticleCombinations || hasArticles ? (
    <>
      <LabelS style={{ fontSize: 14 }} mb="1rem">
        {locale === "nl" ? "Recent bekeken" : "Recently viewed"}
      </LabelS>
      {hasArticleCombinations &&
        articleCombinationData.choicesArticleCombinationsById.map((article) => (
          <Product {...article} key={article.id} type="article-combination" />
        ))}
      {hasArticles &&
        data.choicesArticlesById.map((article) => (
          // @ts-ignore
          <Product
            {...article}
            product_group={article.component}
            key={article.id}
            type="single-product"
          />
        ))}
    </>
  ) : null
}
